<template>
  <div class="jxapgl_main_item" @click="detail">
    <div class="item_title">{{ item.kcmc }}</div>
    <div class="item_skbj">
      <span>上课班级:</span>
      <p>{{ item.ktmc ? item.ktmc : "-" }}</p>
    </div>
    <ul class="item_info">
      <li>
        <span>上课人数:</span>
        <p>{{ item.xkrs ? item.xkrs : "-" }}</p>
      </li>
      <li>
        <span>总学时:</span>
        <p>{{ item.zxs ? item.zxs : "-" }}</p>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    detail() {
      this.$emit("detail", this.item);
    }
  }
};
</script>

<style lang="less" scoped>
.jxapgl_main_item {
  background: #ffffff;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.06);
  border-radius: 8px;
  padding: 14px 15px;
  margin-bottom: 10px;
  .item_title {
    font-family: PingFangSC-Semibold;
    font-size: 16px;
    color: #333333;
    letter-spacing: 0;
    font-weight: bolder;
    line-height: 22px;
    margin-bottom: 6px;
  }
  .item_skbj {
    display: flex;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #666666;
    letter-spacing: 0;
    font-weight: 400;
    margin-bottom: 10px;
    p {
      margin-left: 5px;
    }
  }
  .item_info {
    height: 42px;
    display: flex;
    align-items: center;
    background: #f4f4f4;
    border-radius: 8px;
    li {
      flex: 1;
      display: flex;
      align-items: center;
      line-height: 17px;
      padding-left: 14px;
      span {
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: #666666;
        letter-spacing: 0;
        text-align: center;
        font-weight: 400;
      }
      p {
        margin-left: 5px;
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #333333;
        letter-spacing: 0;
        text-align: center;
        font-weight: bolder;
      }
      & + li {
        border-left: 1px solid #dbdbdb;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/teacher/xkmdck/mode/modeList.vue